// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"2d8d453f","453":"56a29618","615":"45ea6d03","692":"c91b7906"}[chunkId] + ".chunk.js";
};